// src/components/UI/ReceivedPopup.js
import React from 'react';
import Popup from './Popup';

/**
 * ReceivedPopup is used on the Question Received page.
 *
 * For Pending Questions:
 *   - Primary action: "Reply" (opens reply modal)
 *   - Delete: available (with confirmation)
 *   - (No hide/show toggle for pending questions)
 *
 * For Answered Questions:
 *   - Primary action: "View answer" (opens the answer modal)
 *   - Delete: available (with confirmation)
 *   - Toggle display: allows admin to hide/unhide the question
 */
const ReceivedPopup = ({
  q,              // the question object (contains status and displayOnProfile)
  onReply,        // For pending: reply action; for answered: view answer action
  onDelete,       // Delete action (always available)
  onToggleDisplay,// Toggle hide/show action (only for answered questions)
  onClose,        // Callback to close the popup
  confirm,        // If true, show confirmation UI for delete
  onOpenConfirm   // Callback to open the confirmation state
}) => {
  if (q.status === "Pending") {
    return (
      <Popup
        onPrimaryAction={onReply}
        primaryLabel="Reply"
        onDelete={onDelete}
        onClose={onClose}
        confirm={confirm}
        onOpenConfirm={onOpenConfirm}
      />
    );
  } else {
    return (
      <Popup
        onPrimaryAction={onReply}
        primaryLabel="View answer"
        onDelete={onDelete}
        onToggleDisplay={onToggleDisplay}
        displayToggleLabel={q.displayOnProfile ? "Hide from profile" : "Show on profile"}
        onClose={onClose}
        confirm={confirm}
        onOpenConfirm={onOpenConfirm}
      />
    );
  }
};

export default ReceivedPopup;
